export default __webpack_public_path__ + "static/media/bg.092b222f.jpg";